import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import { getService, getServiceFetching, getServiceFetchingError } from '../../state/reducers/services'
import { getServiceProgram } from '../../state/reducers/service-program/service-program'
import ServiceViewDesignatedHotspot from 'src/components/services/view/ServiceViewDesignatedHotspot'

import * as serviceActions from '../../state/actions/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const service = getService(state, ownProps.serviceId)
  const {
    service: { serviceDesignatedZone, items }
  } = state
  let serviceProgram
  if (service && service.serviceProgram) {
    serviceProgram = getServiceProgram(state, service.serviceProgram)
  }

  const { serviceId } = ownProps
  const { designatedHotspotsEnabled } = items[serviceId] || Number('0')

  return {
    service,
    designatedHotspotsEnabled,
    designatedHotspotLocations: serviceDesignatedZone,
    serviceProgram,
    serviceId: ownProps.serviceId,
    fetching: getServiceFetching(state),
    fetchingError: getServiceFetchingError(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getHotspotsList: (serviceId: string): Promise<void> => {
      return dispatch(serviceActions.fetchServiceHotspotList(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewDesignatedHotspot)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewDesignatedHotspots.ts